export const fetchRegions = async (setRegions, domain) => {
    try{
      const response = await fetch(`https://${domain}/api/regions`);
      if (!response.ok){
        throw new Error()
      }
      const data = await response.json();
      return setRegions(data?.regions || []);
    }catch(e){
      console.error(e.message);
      return setRegions([]);
    }
  }
  